const getMidPoint = (firstPoint, secondPoint) => {
    const absX = Math.abs(firstPoint.x - secondPoint.x) / 2;
    const absY = Math.abs(firstPoint.y - secondPoint.y) / 2;
    const midPointX = firstPoint.x > secondPoint.x ? firstPoint.x - absX : secondPoint.x - absX;
    const midPointY = firstPoint.y > secondPoint.y ? firstPoint.y - absY : secondPoint.y - absY;
    return { midPointX, midPointY };
};
const calloutLineRender = (calloutLineObj) => {
    var _a, _b, _c, _d, _e, _f;
    const calloutCanvas = document.getElementById('calloutCanvas');
    if (calloutCanvas) {
        const calloutContext = calloutCanvas.getContext('2d');
        if (calloutContext) {
            const createLine = (line) => {
                if (!line || !line.show) {
                    return;
                }
                const { firstPoint, secondPoint } = line;
                const dpr = window.devicePixelRatio;
                const [firstPointX, firstPointY] = [(firstPoint === null || firstPoint === void 0 ? void 0 : firstPoint.x) * dpr, (firstPoint === null || firstPoint === void 0 ? void 0 : firstPoint.y) * dpr];
                const [secondPointX, secondPointY] = [(secondPoint === null || secondPoint === void 0 ? void 0 : secondPoint.x) * dpr, (secondPoint === null || secondPoint === void 0 ? void 0 : secondPoint.y) * dpr];
                const { midPointX, midPointY } = getMidPoint({
                    x: firstPointX,
                    y: firstPointY,
                    z: 0,
                }, { x: secondPointX, y: secondPointY, z: 0 });
                calloutContext.globalCompositeOperation = 'source-over';
                const text = line.content.toString();
                calloutContext.lineWidth = dpr;
                if (dpr > 1) {
                    calloutContext.font = `${16 + dpr * 2}px Noto IKEA Simplified Chinese-Bold`;
                }
                else {
                    calloutContext.font = '16px Noto IKEA Simplified Chinese-Bold';
                }
                calloutContext.fillStyle = 'black';
                if (dpr > 1) {
                    calloutContext.fillRect(midPointX - calloutContext.measureText(text).width / 2, midPointY - 8, calloutContext.measureText(text).width, 16 + dpr * 2);
                }
                else {
                    calloutContext.fillRect(midPointX - calloutContext.measureText(text).width / 2, midPointY - 8, calloutContext.measureText(text).width, 16);
                }
                calloutContext.fillStyle = 'white';
                if (dpr > 1) {
                    calloutContext.fillText(text, midPointX - calloutContext.measureText(text).width / 2, midPointY + ((16 + dpr * 2) / 2));
                }
                else {
                    calloutContext.fillText(text, midPointX - calloutContext.measureText(text).width / 2, midPointY + 6);
                }
                if (line.title) {
                    const lengthText = line.title;
                    calloutContext.fillStyle = 'black';
                    if (dpr > 1) {
                        calloutContext.fillText(lengthText, midPointX - calloutContext.measureText(lengthText).width / 2, midPointY - (16 + dpr * 2));
                    }
                    else {
                        calloutContext.fillText(lengthText, midPointX - calloutContext.measureText(lengthText).width / 2, midPointY - 16);
                    }
                }
                calloutContext.moveTo(firstPointX, firstPointY);
                calloutContext.lineTo(secondPointX, secondPointY);
                calloutContext.globalCompositeOperation = 'destination-over';
                if (line.isHeight) {
                    calloutContext.moveTo(firstPointX + 3, firstPointY);
                    calloutContext.lineTo(firstPointX - 3, firstPointY);
                    calloutContext.moveTo(secondPointX + 3, secondPointY);
                    calloutContext.lineTo(secondPointX - 3, secondPointY);
                }
                else {
                    calloutContext.moveTo(firstPointX, firstPointY + 3);
                    calloutContext.lineTo(firstPointX, firstPointY - 3);
                    calloutContext.moveTo(secondPointX, secondPointY + 3);
                    calloutContext.lineTo(secondPointX, secondPointY - 3);
                }
            };
            // let width = 0;
            // if (document.documentElement.clientWidth >= 1920) {
            //   width = 1122;
            // } else if (document.documentElement.clientWidth < 1920) {
            //   width = 1080 * 0.516666;
            // }
            const { height } = calloutCanvas;
            calloutCanvas.height = height;
            if (calloutLineObj.renderType) {
                const { bottom, top } = calloutLineObj;
                (_a = top === null || top === void 0 ? void 0 : top.length1) === null || _a === void 0 ? void 0 : _a.forEach((element) => {
                    createLine(element);
                });
                (_b = top === null || top === void 0 ? void 0 : top.length2) === null || _b === void 0 ? void 0 : _b.forEach((element) => {
                    createLine(element);
                });
                (_c = top === null || top === void 0 ? void 0 : top.length3) === null || _c === void 0 ? void 0 : _c.forEach((element) => {
                    createLine(element);
                });
                (_d = bottom === null || bottom === void 0 ? void 0 : bottom.length1) === null || _d === void 0 ? void 0 : _d.forEach((element) => {
                    createLine(element);
                });
                (_e = bottom === null || bottom === void 0 ? void 0 : bottom.length2) === null || _e === void 0 ? void 0 : _e.forEach((element) => {
                    createLine(element);
                });
                (_f = bottom === null || bottom === void 0 ? void 0 : bottom.length3) === null || _f === void 0 ? void 0 : _f.forEach((element) => {
                    createLine(element);
                });
                calloutContext.stroke();
            }
        }
    }
};
export default calloutLineRender;
